import { Theme, Tooltip, withStyles } from '@material-ui/core';
import * as Colors from 'src/theme/colors';

export const AssigneeTooltipWrapper = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: Colors.white,
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
}))(Tooltip);
